module.exports = __webpack_public_path__ + "img/verify_success.5fe9e242.svg";